import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-full tw customfields"
};
const _hoisted_2 = {
  class: "container overflow-hidden tw color-unset lineheight-unset flex flex-col"
};
const _hoisted_3 = {
  class: "flex h-full w-full"
};
const _hoisted_4 = {
  class: "pl-4 p-4 w-full"
};
import { ref, computed, watch } from 'vue';
import CustomFieldsTable from './CustomFieldsTable.vue';
import CustomFieldEditPanel from './CustomFieldEditPanel.vue';
import ProductNotice from '@/components/ProductNotice.vue';
export default {
  __name: 'CustomFieldsPage',
  props: {
    state: {
      type: Object,
      required: false
    },
    alerts: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const tableRef = ref(null);
    const showPanel = ref(false);
    const panelCustomFieldIdOverride = ref(undefined);

    // Computed panel params from URL or local override
    const panelCustomFieldId = computed(() => {
      if (panelCustomFieldIdOverride.value !== undefined) {
        return panelCustomFieldIdOverride.value;
      }
      const params = props.state?.params;
      return params?.customFieldId || null;
    });

    // Watch for panel param to show/hide panel
    watch(() => props.state?.params?.panel, panelParam => {
      showPanel.value = !!panelParam;
    }, {
      immediate: true
    });

    // Handle panel close
    const handlePanelClose = () => {
      showPanel.value = false;
      panelCustomFieldIdOverride.value = undefined;
      if (props.state?.go) {
        props.state.go('settings.company.customFields2', {
          panel: null,
          customFieldId: null
        }, {
          notify: false,
          reload: false
        });
      }
    };

    // Open panel without reloading the table
    const handleOpenPanel = (mode, customField = null) => {
      const id = customField?.id || null;
      panelCustomFieldIdOverride.value = id;
      showPanel.value = true;
      if (props.state?.go) {
        props.state.go('settings.company.customFields2', {
          panel: mode,
          customFieldId: id
        }, {
          notify: false,
          reload: false
        });
      }
    };

    // Handle saved - reload table and close panel
    const handleSaved = () => {
      tableRef.value?.loadCustomFields?.();
      handlePanelClose();
    };

    // Handle panel closed (from table action)
    const handlePanelClosed = () => {
      if (props.state?.go) {
        props.state.go('settings.company.customFields2', {
          panel: null,
          customFieldId: null
        }, {
          notify: false,
          reload: false
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(ProductNotice, {
        state: __props.state,
        label: 'Custom fields are',
        product: 'customFieldMapping'
      }, null, 8, ["state"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(CustomFieldsTable, {
        state: __props.state,
        alerts: __props.alerts,
        ref_key: "tableRef",
        ref: tableRef,
        onPanelClosed: handlePanelClosed,
        onEdit: _cache[0] || (_cache[0] = customField => handleOpenPanel('edit', customField)),
        onCreate: _cache[1] || (_cache[1] = () => handleOpenPanel('create'))
      }, null, 8, ["state", "alerts"])])])]), _createVNode(CustomFieldEditPanel, {
        modelValue: showPanel.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => showPanel.value = $event),
        customFieldId: panelCustomFieldId.value,
        state: __props.state,
        alerts: __props.alerts,
        onClose: handlePanelClose,
        onSaved: handleSaved
      }, null, 8, ["modelValue", "customFieldId", "state", "alerts"])])], 64);
    };
  }
};